module.exports = require("docblock-parser");


//////////////////
// WEBPACK FOOTER
// external "docblock-parser"
// module id = 19
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13 15 17